import { render, staticRenderFns } from "./source-cell.vue?vue&type=template&id=312019d9&scoped=true&"
import script from "./source-cell.vue?vue&type=script&lang=js&"
export * from "./source-cell.vue?vue&type=script&lang=js&"
import style0 from "./source-cell.vue?vue&type=style&index=0&id=312019d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312019d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('312019d9')) {
      api.createRecord('312019d9', component.options)
    } else {
      api.reload('312019d9', component.options)
    }
    module.hot.accept("./source-cell.vue?vue&type=template&id=312019d9&scoped=true&", function () {
      api.rerender('312019d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-table/candidates/source-cell.vue"
export default component.exports